import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    promotions: [],
    promotionsView: {},
    isLoadingPromotions: false,
    isCreateModalVisible: false,
    isUpdateModalVisible: false,
    promotion: {
      id: undefined,
      state: 1,
      type: 0,
      importance: 0,
      canjoin: 1,
      dateFrom: null,
      dateTo: null,
      minusFrom: 0,
      hourlySettlement: 0,
      limitStatus: 0,
      value: 0,
      limitValue: null,
      specialModelType: 0,
      cancelLastQuantity: 0
    },
    created: false,
    updated: false
  },
  getters: {
    getPromotions: (state) => state.promotions,
    getIsLoadingPromotions: (state) => state.isLoadingPromotions,
    getPromotionsView: (state) => state.promotionsView,
    getIsCreateModalVisible: (state) => state.isCreateModalVisible,
    getIsUpdateModalVisible: (state) => state.isUpdateModalVisible,
    getPromotion: (state) => state.promotion,
    getCreated: (state) => state.created,
    getUpdated: (state) => state.updated
  },
  mutations: {
    setCreated (state) {
      state.created = true
    },
    setUpdated (state) {
      state.updated = true
    },
    reset (state) {
      state.created = false
      state.updated = false
      state.promotion = {
        id: undefined,
        state: 1,
        type: 0,
        importance: 0,
        canjoin: 1,
        dateFrom: null,
        dateTo: null,
        minusFrom: 0,
        hourlySettlement: 0,
        limitStatus: 0,
        value: 0,
        limitValue: null,
        specialModelType: 0,
        cancelLastQuantity: 0
      }
    },
    toggleCreateModal (state) {
      state.isCreateModalVisible = !state.isCreateModalVisible
    },
    toggleUpdateModal (state) {
      state.isUpdateModalVisible = !state.isUpdateModalVisible
    },
    setPromotions (state, payload) {
      state.promotions = payload
    },
    setPromotion (state, payload) {
      state.promotion = payload
    },
    toggleLoadingPromotions (state) {
      state.isLoadingPromotions = !state.isLoadingPromotions
    },
    setPromotionsView (state, payload) {
      state.promotionsView = payload
    }
  },
  actions: {
    async fetchPromotions ({ commit }, params) {
      commit('toggleLoadingPromotions')
      const response = await new ApiService('e_x_a_b_promotions', params).getResults()
      commit('setPromotions', await response.items)
      commit('setPromotionsView', await response.view)
      commit('toggleLoadingPromotions')
    },
    async create ({ commit, state }) {
      const response = await new ApiService('e_x_a_b_promotions').post(state.promotion)
      if (response.status >= 200 && response.status < 300) {
        commit('setCreated')
        commit('toggleCreateModal')
      }
    },
    async update ({ commit, state }, id) {
      const response = await new ApiService(id).put(state.promotion)
      if (response.status >= 200 && response.status < 300) {
        commit('setUpdated')
        commit('toggleUpdateModal')
      }
    },
    async retrieve ({ commit }, id) {
      const response = await new ApiService(id).getResults()
      commit('setPromotion', await response)
    }
  }
}
